<div fxLayout fxLayoutAlign="center center">
  <eca-spinner [diameter]=48 color="primary"></eca-spinner>
</div>
